const namespace = 'PARTNERS';

export const REQUEST_PARTNERS = `${namespace}/REQUEST_PARTNERS`;
export const RECEIVE_PARTNERS_SUCCESS = `${namespace}/RECEIVE_PARTNERS_SUCCESS`;
export const RECEIVE_PARTNERS_FAILURE = `${namespace}/RECEIVE_PARTNERS_FAILURE`;

export const REQUEST_GROUPS = `${namespace}/REQUEST_GROUPS`;
export const RECEIVE_GROUPS_SUCCESS = `${namespace}/RECEIVE_GROUPS_SUCCESS`;
export const RECEIVE_GROUPS_FAILURE = `${namespace}/RECEIVE_GROUPS_FAILURE`;
